
export default superclass => class extends superclass {

    // keeps track of the original object and the instance object
    objectRegistry = {};

    registerObject(sourceObject, destObject) {
        this.objectRegistry[sourceObject.id] = destObject;
    }

    lookupObject(sourceObject) {
        return this.objectRegistry[sourceObject.id];
    }
}
